import React from 'react';

export const VolLocRegionModal = {
  title: 'Volcano Location',
  body: (
    <div>
      <p>
        The volcanic subregion (geographic location) as identified by the Smithsonian Institution, Global Volcanism Program.
      </p>
    </div>
  ),
};
